<template>
    <div v-if="!loading">
        <!-- <router-link :to="{name: 'PageWorkSubmit', params: { subject: 1, worksheet: 1 }}" class="alert alert-danger">
            <i class="bi bi-info-circle"></i> {{ $t('未提出のシートがあります') }} (わたしの6月の絵)
                {{ $t('締切を過ぎているシートがあります') }} -->
        <!-- </router-link>  -->

        <template v-if="student_subjects.length">
            <div class="accordion">
                <template v-for="(student_subject, index) in student_subjects" :key="student_subject">
                    <div class="accordion-item">
                        <h2 class="accordion-header">
                        <button class="accordion-button text-primary fw-bold" type="button" data-bs-toggle="collapse" :data-bs-target="`#subject-${index}`" :class="{collapsed: index !== 0}">
                            <i class="bi bi-book me-2 fs-3"></i> {{ student_subject.subject.subject_name }}
                        </button>
                        </h2>
                        <div :id="`subject-${index}`" class="accordion-collapse collapse" :class="{show: index === 0}">
                            <div class="accordion-body ms-4">
                                <h5 class="bg-light text-center mb-3 p-2">{{ $t('ふり返りシート') }}</h5>
                                <div class="d-flex justify-content-between pb-3 border-bottom">
                                    <template v-if="student_subject.write_active">
                                        <template v-if="student_subject.active_student_worksheets.length > 1">
                                            <button type="button" class="btn btn-success" @click="openSelectWorksheetModal(student_subject)" style="width:40%;">
                                                <i class="bi bi-pencil-fill"></i> {{ $t('書く') }}
                                            </button>
                                        </template>
                                        <template v-else>
                                            <router-link
                                                :to="{name: 'PageWorkSubmit', params: { subject: student_subject.subject.planned_subject_id, worksheet:student_subject.active_student_worksheets[0].student_worksheet_id }}"
                                                class="btn btn-success"
                                                style="width:40%;"
                                            >
                                                <i class="bi bi-pencil-fill"></i> {{ $t('書く') }}
                                            </router-link>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <button type="button" class="btn btn-success" disabled style="width:40%;">
                                            <i class="bi bi-pencil-fill"></i> {{ $t('書く') }}
                                        </button>
                                    </template>

                                    <template v-if="student_subject.read_active">
                                        <router-link
                                            :to="{name: 'PageWorkList', params: { subject: student_subject.subject.planned_subject_id }}"
                                            class="btn btn-info" style="width:40%;"
                                        >
                                            <i class="bi bi-book"></i> 見る
                                        </router-link>
                                    </template>
                                    <template v-else>
                                        <button type="button" class="btn btn-info" disabled style="width:40%;">
                                            <i class="bi bi-book"></i> 見る
                                        </button>
                                    </template>
                                </div>

                                <div class="mt-3 d-flex justify-content-between" v-if="student_subject.gallery_active">
                                    <router-link
                                        :to="{name: 'PageGallery', params: { subject: student_subject.subject.planned_subject_id }}"
                                        class="btn btn-warning" style="width:40%;"
                                    >
                                        <i class="bi bi-image"></i> {{ is_muji ? $t('みんなの写真') : $t('みんなの作品') }}
                                    </router-link>
                                    <div class="d-flex justify-content-between" style="width:40%;">
                                        <router-link
                                            v-if="student_subject.subject.option_comment !== OptionComment.NONE &&
                                            student_subject.total_comment_count > 0"
                                            :to="{name: 'PageGalleryCommentToMe', params: { subject: student_subject.subject.planned_subject_id }}"
                                            class="btn btn-outline-light d-flex align-items-center"
                                        >
                                            <i class="bi bi-chat-fill text-success me-1"></i> <strong class="text-black">{{ student_subject.total_comment_count }}</strong>
                                        </router-link>
                                        <span
                                            v-if="student_subject.subject.option_like !== OptionLikePermission.NONE && student_subject.total_like_count > 0"
                                            class="d-flex align-items-center py-1 px-3"
                                        >
                                            <i class="bi bi-heart-fill text-danger me-1"></i> <strong class="text-black">{{ student_subject.total_like_count }}</strong>
                                        </span>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center mt-3" v-if="student_subject.information_active">
                                    <div>
                                        <button type="button" class="btn btn-secondary" @click="openEvaluationModal(student_subject)">
                                            <i class="bi bi-info-circle-fill"></i> {{ $t('題材情報') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </template>
        <template v-else>
            <alert-no-record :text="`まだ${$t('配られ')}ていません`" optional_class="m-2"></alert-no-record>
        </template>
    </div>

    <div v-if="modal.worksheet">
        <transition name="fade">
            <div class="modal_inner">
                <div class="modal-backdrop show"></div>
                <div class="modal" tabindex="-1" style="display:block">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <!-- modal head -->
                            <div class="modal-header">
                                <h4 class="modal-title">
                                    <i class="bi bi-pencil-fill"></i> {{ $t('ふり返りシートを書く') }}
                                </h4>
                                <button type="button" class="btn-close" @click="closeSelectWorksheetModal()"></button>
                            </div>
                            <!-- modal body -->
                            <div class="modal-body">
                                <ul class="list-group">
                                    <template v-for="row of target_student_subject.active_student_worksheets" :key="row">
                                        <li class="list-group-item">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div class="col-12">
                                                    {{ row.planned_worksheet.worksheet_name }}
                                                </div>
                                                <div class="col-12 text-end">
                                                    <router-link
                                                        :to="{name: 'PageWorkSubmit', params: { subject: target_student_subject.subject.planned_subject_id, worksheet:row.student_worksheet_id }}"
                                                        class="btn btn-success"
                                                    >
                                                        <i class="bi bi-pencil-fill"></i> {{ $t('書く') }}
                                                    </router-link>
                                                </div>
                                            </div>
                                        </li>
                                    </template>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>

    <!-- 題材情報モーダル -->
    <div v-if="modal.evaluation">
        <transition name="fade">
            <div class="modal_inner">
                <div class="modal-backdrop show"></div>
                <div class="modal" tabindex="-1" style="display:block">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <!-- modal head -->
                            <div class="modal-header">
                                <h4 class="modal-title"><i class="bi bi-info-circle"></i> {{ target_subject_evaluation.subject_name }}</h4>
                                <button type="button" class="btn-close" @click="closeEvaluationModal()"></button>
                            </div>
                            <!-- modal body -->
                            <div class="modal-body">
                                <div class="card mb-3">
                                    <div class="card-header">
                                        チャレンジ
                                    </div>
                                    <div class="card-body">
                                        <p class="card-text multiline">
                                            {{ target_subject_evaluation.description }}
                                        </p>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header">
                                        めあて
                                    </div>
                                    <ul class="list-group list-group-flush">
                                        <li v-if="target_subject_evaluation.evaluation_item_1" class="list-group-item">
                                            {{ target_subject_evaluation.evaluation_item_1 }}
                                        </li>
                                        <li v-if="target_subject_evaluation.evaluation_item_2" class="list-group-item">
                                            {{ target_subject_evaluation.evaluation_item_2 }}
                                        </li>
                                        <li v-if="target_subject_evaluation.evaluation_item_3" class="list-group-item">
                                            {{ target_subject_evaluation.evaluation_item_3 }}
                                        </li>
                                        <li v-if="target_subject_evaluation.evaluation_item_4" class="list-group-item">
                                            {{ target_subject_evaluation.evaluation_item_4 }}
                                        </li>
                                        <li v-if="target_subject_evaluation.evaluation_item_5" class="list-group-item">
                                            {{ target_subject_evaluation.evaluation_item_5 }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import PlannedSubject from '@/shared/models/entities/repocraft/planned-subject';
import StudentWorksheet from '@/shared/models/entities/repocraft/student-worksheet';
import AlertNoRecord from '@/shared/components/design/AlertNoRecord.vue';
import OptionComment from '@/shared/models/enums/option-comment';
import OptionLikePermission from '@/shared/models/enums/option-like-permission';

export default {
    name: 'PageHome',
    components: {
        AlertNoRecord,
    },
    inject: [
        'startScreenLoading',
        'endScreenLoading',
        'showMessage',
        'showErrorMessage',
    ],
    data() {
        return {
            //部分ローダー
            loading: false,

            // レポクラフト無地判定
            is_muji: false, //default = repocraft

            //モーダル
            modal:{
                worksheet: false,
                evaluation: false
            },
            target_student_subject: {},
            target_subject_evaluation: new PlannedSubject(),

            //ログイン中のユーザに関わる題材の一覧
            student_subjects: [],

            //enums
            OptionComment: OptionComment,
            OptionLikePermission: OptionLikePermission,

        }
    },
    mounted() {
         //題材の一覧を取得
        this.getStudentSubjects();
    },
    methods: {
        //題材の一覧を取得
        getStudentSubjects() {
            this.loading = true;
            this.startScreenLoading();
            this.$http.get('/repocraft/subject')
            .then(response => {
                for (let row of response.data) {
                    //即席のオブジェクトを作成
                    var student_subject = {
                        subject: new PlannedSubject(),
                        active_student_worksheets: [],
                        information_active: false,
                        write_active: false,
                        read_active: false,
                        gallery_active: false,
                        total_like_count: 0,
                        total_comment_count: 0,
                    };

                    //オブジェクトに値を詰める
                    for (let active_student_worksheet of row.active_student_worksheets) {
                        student_subject.active_student_worksheets.push(new StudentWorksheet(active_student_worksheet));
                    }
                    student_subject.subject = new PlannedSubject(row.subject);
                    student_subject.information_active = row.information_active;
                    student_subject.write_active = row.write_active;
                    student_subject.read_active = row.read_active;
                    student_subject.gallery_active = row.gallery_active;
                    student_subject.total_like_count = row.total_like_count;
                    student_subject.total_comment_count = row.total_comment_count;

                    this.student_subjects.push(student_subject);
                }

                //レポクラフト/レポクラフト無地を判定
                if (this.student_subjects[0].subject.app_key === 'repocraft_muji') {
                    this.is_muji = true;
                }
            })
            .finally(() => {
                this.loading = false;
                this.endScreenLoading();
            });
        },
        //未提出or再提出の児童シートシートが1つ以上あったときは、モーダルを開き、どのシートシートかを選択させる
        //そのためのモーダルをあける
        openSelectWorksheetModal(student_subject) {
            this.target_student_subject = student_subject;
            this.modal.worksheet = true;
        },
        closeSelectWorksheetModal() {
            this.target_student_subject = {};
            this.modal.worksheet = false;
        },
        //題材情報モーダルオープン
        openEvaluationModal(student_subject) {
            this.startScreenLoading();

            this.$http.get(`/repocraft/subject/${student_subject.subject.planned_subject_id}`)
            .then(response => {
                this.target_subject_evaluation = new PlannedSubject(response.data);
            })
            .finally(() => {
                this.endScreenLoading();
                this.modal.evaluation = true;
            });
        },
        //題材情報モーダルクローズ
        closeEvaluationModal() {
            this.modal.evaluation = false;
            this.target_subject_evaluation = new PlannedSubject();
        }
    },
}
</script>

<style scoped>
a.alert {display: block; text-decoration: none;}
</style>
